<h2 mat-dialog-title>{{'filters.filter_settings' | translate}}</h2>



<mat-dialog-content style="max-width: 400px;">
  <div class="pt-2 pb-3">
    <section class="mt-1 mb-3 rounded m-auto w-100" id="section" >

      <form [formGroup]="filterForm" style="overflow-y: auto;">
        <mat-accordion class=" mb-1 mt-1">
          @for (filter of reportTemplate.filters; track filter; let index = $index) {
            <mat-expansion-panel (opened)="panelOpenState = true"
              (closed)="panelOpenState = false" class="m-2">
              <mat-expansion-panel-header>
                <mat-panel-title>{{filter.displayName}}</mat-panel-title>
                <mat-panel-description>
                  {{filterForm.value[filter.key+'_description']}}
                </mat-panel-description>
              </mat-expansion-panel-header>
              @if (filter.key) {
                <div>
                  <div class="form-control d-flex justify-content-between rounded mt-1 mb-3 w-100 p-3">
                    <span class="text-wrap" style="background-color: var(--pureWhite);">{{'reports.key' | translate}}    </span>
                    <label class=" text-muted" style="border-left: none;text-align: end;">{{filter.key}}</label>
                  </div>
                  <mat-form-field appearance="outline" class="w-100 ">
                    <mat-label>{{'displayName' | translate}}</mat-label>
                    <input matInput type="text" class="form-control" placeholder="{{'displayName' | translate}}" formControlName="{{filter.key}}_displayName" required>
                  </mat-form-field>
                  <mat-form-field appearance="outline" class="w-100">
                    <mat-label>{{'reports.type' | translate}}</mat-label>
                    <mat-select formControlName="{{filter.key}}_type" required>
                      @for (type of typeOptions; track type; let index = $index) {
                        <mat-option value="{{type.type}}" >{{type.translation | translate}}</mat-option>
                      }
                    </mat-select>
                  </mat-form-field>
                  <!-- <mat-form-field appearance="outline" class="w-100 " disabled>
                  <mat-label>{{'reports.key' | translate}}</mat-label>
                  <input matInput type="text" class="form-control" placeholder=" {{'reports.key' | translate}}" formControlName="{{filter.key}}_key" required readonly>
                </mat-form-field> -->
                <!--
                <div class=" form-control d-flex justify-content-between rounded mt-1 mb-3 w-100 p-3">
                  <span class="text-wrap" style="background-color: var(--pureWhite);">{{'reports.type' | translate}}    </span>
                  <label class=" text-muted" style="border-left: none;text-align: end;">{{filter.type}}</label>
                </div>
                <div class="form-control d-flex justify-content-between rounded mt-1 mb-3 w-100 p-3">
                  <span class="text-wrap" style="background-color: var(--pureWhite);">{{'description' | translate}}    </span>
                  <label class=" text-muted" style="border-left: none;text-align: end;">{{filter.description}}</label>
                </div>
                <mat-form-field appearance="outline" class="w-100" *ngIf="filter.type!='boolean' ">
                  <mat-label>{{filter.displayName}} </mat-label>
                  <input matInput *ngIf="filter.type=='string' " type="text" formControlName="{{filter.key}}">
                  <input matInput *ngIf="filter.type=='text' " type="text" formControlName="{{filter.key}}">
                  <input matInput *ngIf="filter.type=='media' " type="text" formControlName="{{filter.key}}">
                  <input matInput *ngIf="filter.type=='number' " type="number" formControlName="{{filter.key}}">
                  <input matInput *ngIf="filter.type=='decimal' " type="number" formControlName="{{filter.key}}" step="0.1">
                  <input matInput *ngIf="filter.type=='date' " type="date" formControlName="{{filter.key}}">
                  <input matInput *ngIf="filter.type=='time' " type="time" formControlName="{{filter.key}}">
                  <input matInput *ngIf="filter.type=='dateTime' " type="datetime-local" formControlName="{{filter.key}}" >
                </mat-form-field>
                <div  class="form-control p-3 mb-3  d-flex justify-content-between" *ngIf="filter.type=='boolean' ">
                  <label for="{{filter.key}}" >{{filter.displayName}}</label>
                  <mat-slide-toggle  class="ms-5 example-margin" formControlName="{{filter.key}}" ></mat-slide-toggle>
                </div> -->
                <mat-form-field appearance="outline" class="w-100 ">
                  <mat-label>{{'contentTypes.description' | translate}}</mat-label>
                  <input matInput type="text" class="form-control" placeholder="{{'contentTypes.description' | translate}}" formControlName="{{filter.key}}_description">
                </mat-form-field>
                <mat-form-field appearance="outline" class="w-100">
                  <mat-label>{{'reports.operator' | translate}}</mat-label>
                  <mat-select formControlName="{{filter.key}}_operator" required>
                    @for (operator of operatorOptions; track operator; let index = $index) {
                      <mat-option value="{{operator.value}}"  disabled="{{checkFilterTypeOperatorRange(filter.type, operator)}}" >{{operator.translation | translate}}</mat-option>
                    }
                  </mat-select>
                </mat-form-field>
                        <!-- <div *ngIf="(filterForm.value[filter.key+'_type']=='string' || filterForm.value[filter.key+'_type']=='number' || filterForm.value[filter.key+'_type']=='decimal') && (filterForm.value[filter.key+'_operator'] == '=' || filterForm.value[filter.key+'_operator'] == '!=') " >
                            <span class="fs-6">{{'filters.options' | translate}}</span>

                            <div class="d-flex flex-column mt-2">
                                <mat-form-field appearance="outline" class="pe-1 flex-grow-1" >
                                    <mat-label>{{'filters.option' | translate}}</mat-label>
                                    <input matInput *ngIf="filterForm.value[filter.key+'_type']=='number'" type="number" class="form-control" placeholder="{{'filters.option' | translate}}" formControlName="{{filter.key}}_newOption">
                                    <input matInput *ngIf="filterForm.value[filter.key+'_type']=='decimal'" type="number" class="form-control" step="0.1" placeholder="{{'filters.option' | translate}}" formControlName="{{filter.key}}_newOption" >
                                    <input matInput *ngIf="filterForm.value[filter.key+'_type']=='string' " type="text" formControlName="{{filter.key}}_newOption" placeholder="{{'filters.option' | translate}}" >
                                    <input matInput *ngIf="!filterForm.value[filter.key+'_type'] " type="text" formControlName="{{filter.key}}_newOption">
                                </mat-form-field>

                                <button mat-button class="secondary-gray-button" id="btn-add" [disabled]="!filterForm.value[filter.key+'_newOption']" (click)="addOptionFilter(filter)">
                                    <mat-icon>add_circle</mat-icon> {{'add' | translate}}
                                </button>

                                <hr *ngIf="filterForm.value[filter.key+'_options']?.length > 0" class="my-3">

                                <div *ngFor="let option of filterForm.value[filter.key+'_options']; let optionIndex = index;">
                                    <mat-card class="mb-1">
                                        <mat-card-content class="py-0">
                                            <div class="d-flex align-items-center" style="justify-content: space-between;">
                                                <div>{{option}}</div>

                                                <button class="delete-button" style="vertical-align: middle;" mat-icon-button (click)="deleteOptionFilter(filter,  option,optionIndex)" [disabled]="filterForm.value[filter.key+'_options']?.length == 0">
                                                    <mat-icon class="material-symbols-outlined">delete</mat-icon>
                                                </button>
                                            </div>
                                        </mat-card-content>
                                    </mat-card>
                                </div>
                            </div>
                        </div> -->
                    </div>
}

                </mat-expansion-panel>
}
            </mat-accordion>
        </form>

        </section>
    </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button style="color:var(--warmOrange);" (click)="onCancel();" >
        {{'cancel' | translate}}
  </button>
  <button mat-button class="orange-button"
  (click)="onSave();">{{'save' | translate}}</button>
</mat-dialog-actions>
